import {
  Tabs,
  Input,
  Row,
  Col,
  Card,
  Tag,
  Dropdown,
  Button,
  Space,
  Badge,
} from "antd";
import {
  MoreOutlined,
  CheckCircleOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import ReactGA from "react-ga4";

const ProductListCard = ({ product, showProdStatus, showPrice, onClick }) => {
  const { categoryName } = useParams();
  const statusColors = {
    Available: "green",
    "Out of Stock": "orange",
  };

  const handleCardClick = () => {
    const IsEmployee = localStorage.getItem("IsEmployee");

    if (IsEmployee === "false") {
      ReactGA.event({
        category: "Product",
        action: "clicked on product card",
        label: product.DesignNo, // optional
        value: product.ProductID, // optional, must be a number
        nonInteraction: false, // optional, true/false
        transport: "xhr", // optional, beacon/xhr/image
      });
    }

    sessionStorage.setItem("ProductID", product.ProductID);

    // Call the handler passed from parent (ProductList.js)
    if (onClick) {
      onClick(product);
    }
  };

  // Determine Tag1 and Tag2
  const ribbonText =
    product.Tag1 && product.Tag1.trim() !== "" ? product.Tag1 : null;
  const badgeText =
    product.Tag2 && product.Tag2.trim() !== "" ? product.Tag2 : null;

  return (
    <Badge.Ribbon
      text={ribbonText}
      color="purple"
      style={ribbonText ? {} : { display: "none" }}
    >
      <Card
        hoverable
        cover={
          <div style={{ position: "relative" }}>
            <img
              alt={product.ProductName}
              src={product.ImageUrl}
              style={{
                height: window.innerWidth <= 768 ? "150px" : "300px",
                width: "100%",
                objectFit: "cover",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            />
            {product.NoOfColor ? (
              product.NoOfColor > 1 ? (
                <Tag
                  style={{
                    backgroundColor: "#1677ff",
                    position: "absolute",
                    bottom: 10,
                    right: 10,
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  {product.NoOfColor} - Variants
                </Tag>
              ) : null
            ) : null}
          </div>
        }
        onClick={handleCardClick}
        style={{
          border:
            showProdStatus === true
              ? product.Status === "Available"
                ? "1px solid #52c41a"
                : undefined
              : "1px solid rgb(39, 178, 196)",
          height:
            !showPrice && !localStorage.getItem("token")
              ? window.innerWidth <= 768
                ? "300px" // Decrease height if not logged in
                : "auto"
              : window.innerWidth <= 768
              ? "345px"
              : "auto",
          transition: "height 0.2s",
        }}
        actions={["View Product Details"]}
      >
        {showProdStatus && (
          <>
            <Tag style={{ marginTop: 0 }} color={statusColors[product.Status]}>
              {product.Status}
            </Tag>{" "}
            {badgeText && (
              <Badge
                status="processing"
                text={badgeText}
                color="purple"
                style={{ color: "purple" }}
              />
            )}{" "}
          </>
        )}
        {window.innerWidth > 768 ? (
          <h4
            style={{
              margin: "10px 0 4px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              display: "block",
            }}
            title={product.ProductName}
          >
            {product.ProductName}
          </h4>
        ) : (
          <h4 style={{ margin: "0px 0 0px" }}>{product.DesignNo}</h4>
        )}

        {window.innerWidth > 768 ? (
          <>
            <p style={{ marginTop: 0, marginBottom: 0, color: "#888" }}>
              {"Design No. : " + product.DesignNo}
            </p>

            <p style={{ marginBottom: 0, color: "#888", marginTop: 0 }}>
              {"Box Size : " + product.QtyInBox + " " + product.Unit + "(s)"} |{" "}
              {"Colors : " + product.NoOfColor}
            </p>
          </>
        ) : null}

        {showPrice ? (
          product.DealRate &&
          product.DealRate > 0 &&
          product.DealRate < product.SalesRate ? (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span
                style={{
                  textDecoration: "line-through",
                  color: "#888",
                  fontSize: 16,
                  fontWeight: 400,
                }}
              >
                ₹{product.SalesRate.toFixed(2)}
              </span>
              <span
                style={{ color: "green", fontWeight: "bold", fontSize: 18 }}
              >
                ₹{product.DealRate.toFixed(2)}
              </span>
            </div>
          ) : (
            <span
              style={{ color: "#08979c", fontWeight: "bold", fontSize: 18 }}
            >
              ₹{product.SalesRate?.toFixed(2)}
            </span>
          )
        ) : (
          <span style={{ color: "#00c5ff", fontWeight: 500 }}>
            Login to View Price
          </span>
        )}
      </Card>
    </Badge.Ribbon>
  );
};

export default ProductListCard;
